import React from 'react';
import styled from 'styled-components';

const Styles = styled.div<Partial<HeaderProps>>`
    &&& {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        padding: 15px 10px;

        .title {
            margin: 0;
            font-size: 18px;
            color: #555;
            opacity: 0.8;
        }

        .close-wrapper {
            position: relative;
            cursor: pointer;
            width: 20px;
            height: 20px;
            padding: 5px;
            border: none;
            text-align: center;

            span {
                color: #3197c8;

                &:hover {
                    color: #174558;
                }
            }
        }

        .close-wrapper-icon {
            position: absolute;
            top: -6px;
            left: 3px;
            font-size: 20px;

            color: #999895;
        }
    }
`;

export type HeaderProps = {
    handleClose: () => void;
    title: string;
};

const Header = ({ handleClose, title }: HeaderProps) => {
    return (
        <Styles>
            <h5 className="title">{title}</h5>

            <div onClick={handleClose} className="close-wrapper">
                <div className="close-wrapper-icon">
                    <span className="fa fa-close"></span>
                </div>
            </div>
        </Styles>
    );
};

export default Header;
